import React, { memo } from 'react'
import {
  Box, EmptyStarIcon, FullStarIcon, HalfStarIcon, IcoMoon,
} from '@usap/uicomponents'

const styleCSS = { display: 'block' }

const generateStars = (rating, size) => {
  const data = []
  let starVar = 0
  let ratingLocal = rating

  // eslint-disable-next-line no-plusplus
  for (starVar = 0; starVar < 5; ratingLocal--, starVar++) {
    if (ratingLocal >= 1) {
      data.push(
        <IcoMoon key={`${ratingLocal}${starVar}`} icon={FullStarIcon} size={size} />,
      )
    } else if (ratingLocal > 0 && ratingLocal < 1) {
      data.push(
        <IcoMoon key={`${ratingLocal}${starVar}`} icon={HalfStarIcon} size={size} />,
      )
    } else {
      data.push(
        <IcoMoon
          key={`${ratingLocal}${starVar}`}
          icon={EmptyStarIcon}
          size={size}
        />,
      )
    }
  }
  return data
}

const StarCount = ({
  ratings, size = '16px', showIfZero = true, flex = false,
}) => {
  if (!showIfZero && !ratings) {
    return null
  }
  return (
    <Box direction="row" style={flex ? {} : styleCSS} wrap={false}>
      {generateStars(ratings, size)}
      <Box size="xsmall">{/* {props.label} */}</Box>
    </Box>
  )
}

export default memo(StarCount)
